var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { motion } from "framer-motion";
import AccordionItem from './accordionItem';
export default function StripVerticalColorAccordionContainer(props) {
    var fields = props.fields;
    var TitleTag = (fields.titleTag || 'h2');
    var cardVariants = {
        offscreen: {
            opacity: 1
        },
        onscreen: {
            opacity: 1
        }
    };
    var getBackgroundColor = function (colours) {
        var color = colours.split('/');
        if (color[0].length > 0) {
            return "bg-" + color[0];
        }
        return "no-bg";
    };
    return (React.createElement(motion.div, __assign({ initial: "offscreen", whileInView: "onscreen", viewport: { once: true, margin: "-30%" }, className: "strip sky23-vertical-color-accordion container-fluid position-relative component"
            + (!fields.showNumbers ? " hide-numbers" : "") }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        false &&
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col col-lg-6 offset-lg-3" },
                    React.createElement("div", { className: "d-flex flex-column text-container justify-content-center align-items-center text-center text-olive component-intro" },
                        fields.displayTitle &&
                            React.createElement(TitleTag, { className: "display-4 " + fields.titleStyle, dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                        fields.content &&
                            React.createElement("p", { className: "fs-5", dangerouslySetInnerHTML: { __html: fields.content } })))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col col-xxl-auto mx-auto" },
                React.createElement("div", { className: "vertical-color-accordion-wrapper mx-auto " },
                    React.createElement("div", { className: "accordion accordion-flush vertical-color-accordion", id: props.id ? props.id : "accordionFlushExample" }, props.children && props.children.length > 0 && props.children.map(function (item, index) {
                        var dataBsParent = "#" + (props.id ? props.id : "accordionFlushExample");
                        return (React.createElement(motion.div, { key: item.id, variants: cardVariants, className: "accordion-item"
                                + (item.fields.color ? (" bg-" + item.fields.color) : "no-bg")
                                + (item.fields.textColour ? (" text-" + item.fields.textColour) : "") },
                            React.createElement(AccordionItem, { item: item, index: index, dataBsParent: dataBsParent })));
                    })))))));
}
